module.exports = __webpack_public_path__ + "static/media/collen-construction.55fa5e07.png";